import React, {useCallback, useEffect, useState} from "react";
import {Box, Button, Modal, Stack, TextField, Typography} from "@mui/material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function ModalChangeName({open, handleClose, handleSubmit, initialName = ""}) {
    const [name, setName] = useState("");

    useEffect(() => {
        if (open) setName(initialName || "");
    }, [open, initialName]);

    const handleFormSubmit = useCallback(
        (e) => {
            e.preventDefault();
            handleSubmit(name);
            handleClose();
        },
        [name, handleSubmit, handleClose]
    );

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>
                    Изменить имя
                </Typography>
                <form onSubmit={handleFormSubmit}>
                    <Stack spacing={2}>
                        <TextField
                            label="Новое имя"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            fullWidth
                        />
                        <Button type="submit" variant="contained" disabled={!name.trim()}>
                            Изменить
                        </Button>
                    </Stack>
                </form>
            </Box>
        </Modal>
    );
}

